import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import VueGoogleApi from 'vue-google-api'
import numeral from 'numeral'
import signalr from '@/utils/signalr' // SAKIN SİLME, IDEYE KANMA!
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Notifications);

Vue.use(VueGoogleApi, {
    apiKey: 'gerek var mi',
    clientId: '418303477464-iocmlr38kne2l18s2diafo5ghrv9phue.apps.googleusercontent.com',
    //clientId: '418303477464-ahq1rof1n3cl290dnkhisrrdha9f2lcr.apps.googleusercontent.com',
    /*  scope: 'space_separated_scopes',*/
});

Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0");
});

Vue.filter("replaceComma", function (value) {
    return value.replace(',', '.')
});

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueCropper from "vue-cropper"

Vue.use(VueCropper);

String.prototype.replaceAll = function (find, replace) {
    let str = this;
    return str.replace(new RegExp(find, 'g'), replace);
};

Vue.config.productionTip = false;
Vue.config.devtools = true;

export var vApp = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
window.vApp = vApp;